import React from 'react'
import Header from "@/pages/home/components/Header"
import Footer from "@/pages/home/components/Footer"

export default function PrivacyPolicy() {
  return (
    <>
    <Header />
    <section className="py-20 bg-gradient-to-br from-pink-50 to-teal-50 text-gray-800">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-4xl font-bold mb-10 text-center">プライバシーポリシー</h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 leading-relaxed space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3">1. 個人情報の利用目的</h2>
            <p>
              株式会社Ｍｓ Ｐｌａｎｔａｇｅ（以下、「当社」といいます）は、
              お問い合わせフォーム等を通じて取得したお客様の個人情報を、
              以下の目的で利用いたします。
            </p>
            <ul className="list-disc list-inside mt-3 space-y-1">
              <li>お問い合わせ内容への回答および必要なご連絡のため</li>
              <li>サービス提供およびご案内のため</li>
              <li>サービス改善や新サービス開発のための分析・検討のため</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">2. 個人情報の第三者提供について</h2>
            <p>
              当社は、法令に基づく場合を除き、
              ご本人の同意なく第三者に個人情報を提供することはありません。
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">3. 個人情報の管理</h2>
            <p>
              当社は、個人情報を正確かつ最新の内容に保つよう努めるとともに、
              不正アクセス・紛失・破壊・改ざん・漏えい等を防止するため、
              適切な安全対策を講じます。
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">4. 個人情報の開示・訂正・削除について</h2>
            <p>
              お客様ご本人から、当社が保有する個人情報の開示・訂正・削除等の
              ご要望があった場合は、ご本人確認のうえ、速やかに対応いたします。
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">5. クッキー（Cookie）等の利用について</h2>
            <p>
              当サイトでは、利用状況の把握やサービス改善のために
              クッキー（Cookie）やアクセス解析ツールを利用する場合があります。
              これらにより個人を特定できる情報を取得することはありません。
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">6. プライバシーポリシーの変更</h2>
            <p>
              本ポリシーの内容は、法令等の変更や当社の運営方針により、
              予告なく改定される場合があります。
              変更後のプライバシーポリシーは、当サイト上に掲載した時点で効力を生じます。
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">7. お問い合わせ窓口</h2>
            <p>
              本ポリシーに関するお問い合わせは、下記窓口までお願いいたします。
            </p>
            <div className="mt-3 border-t pt-3 text-sm text-gray-700">
              <p>株式会社Ｍｓ Ｐｌａｎｔａｇｅ</p>
              <p>〒546-0043 大阪府大阪市東住吉区駒川3-27-39 プレジオールKOMAGAWA204</p>
              <p>メールアドレス：main@ms-plantage.com</p>
              <p>電話番号：03-6820-7534</p>
            </div>
          </section>

          
        </div>
      </div>
    </section>
    <Footer />
    </>
  )
}
